<template>
    <base-layout
        :header-type="headerType.ALL"
        :footer-type="footerType.COPYRIGHTONLY"
        :latest-image-id="latestImageId"
        :unsaved-puri-count="unsavedPuriCount"
    >
        <error-not-found-content />
    </base-layout>
</template>

<script>
import BaseLayout from "../templates/BaseLayout.vue";
import ErrorNotFoundContent from "../organisms/ErrorNotFoundContent.vue";
import {headerType} from "../../view-model/enum/HeaderType";
import {footerType} from "../../view-model/enum/FooterType";
import {mapActions, mapGetters} from "vuex";
export default {
    name: "ErrorNotFound",
    components: {
        ErrorNotFoundContent,
        BaseLayout,
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        }
    },computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus'
        }),
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         * vue-router側でaccountStatusをdispachしていない場合のみgetAccountStatus()する
         */
        if(!this.accountStatus) {
            this.getAccountStatus()
        }
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        })
    }
}
</script>
